import {get} from 'lodash';

import CheckboxField from 'components/CheckboxField';
import Typography from 'components/Typography';

import {Order, OrderType} from 'types';

import styles from './InboxTicket.module.scss';
import classNames from 'classnames';
import StatusBadge from 'components/StatusBadge';
import {PinIcon} from 'pages/DeliveryPlanner/components/OrderDetailsModal/icons';

interface TicketProps {
  ticket: Order;
  index?: number;
  selected?: boolean;
  onChangeCheckbox: (id: number, checked: boolean) => void;
  // onOrdersClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  isError?: boolean;
}

function Ticket({ticket, index, selected, onChangeCheckbox}: TicketProps) {
  const delivery_address = ticket?.delivery_address;
  const id = ticket?.id;

  const customer = ticket?.customer;
  const source_id = ticket?.source_id;
  const order_type = ticket?.order_type;
  const sequential_order_number = ticket?.sequential_order_number;

  const renderOrderType = (order_type?: OrderType) => {
    if (order_type === 'pickup') {
      return (
        <StatusBadge color="default" className={styles.orderTypeBadge}>
          P{source_id}
        </StatusBadge>
      );
    }
    if (order_type === 'dropoff') {
      return (
        <StatusBadge color="green" className={styles.orderTypeBadge}>
          C{source_id}
        </StatusBadge>
      );
    }
    return null;
  };
  return (
    <div
      className={classNames(
        styles.root,
        // Add border color for invalid addresses or error states
        typeof delivery_address !== 'string' &&
          !delivery_address?.is_valid &&
          styles.borderColor
      )}
    >
      <div style={{marginBottom: index ? 0 : 8}} className={styles.top}>
        {/* Checkbox for order selection */}
        <CheckboxField
          name={`checkbox-${id}`}
          className={styles.checkbox}
          label={`#${source_id || sequential_order_number}`}
          checked={selected}
          onChange={() => onChangeCheckbox(id, !selected)}
        />
        {typeof customer === 'string' ? (
          <Typography className={styles.customer} variant="p">
            {customer}
          </Typography>
        ) : (
          <Typography className={styles.customer} variant="p">
            {get(customer, 'user.first_name', '')}{' '}
            {get(customer, 'user.last_name', '')}
          </Typography>
        )}
        {renderOrderType(order_type)}
      </div>

      {typeof delivery_address === 'string' ? (
        <div className={styles.addressContainer}>
          <PinIcon className={styles.pinIcon} />
          <Typography className={styles.addressCalc} variant="p">
            {delivery_address}
          </Typography>
        </div>
      ) : (
        <div className={styles.addressContainer}>
          <PinIcon className={styles.pinIcon} />
          {delivery_address?.display_address && (
            <Typography className={styles.address} variant="p">
              {delivery_address?.display_address}
            </Typography>
          )}
          {!delivery_address?.display_address && (
            <Typography className={styles.address} variant="p">
              {[
                delivery_address?.address_line_1,
                delivery_address?.address_line_2,
                delivery_address?.city,
                delivery_address?.state,
                delivery_address?.zipcode,
              ]
                .filter(Boolean)
                .join(', ')}
            </Typography>
          )}
        </div>
      )}
      {/* Delivery address - handle both string and object formats */}
      {/* {typeof delivery_address === 'string' ? (
        <Typography className={styles.addressCalc} variant="p">
          {delivery_address}
        </Typography>
      ) : (
        <Typography className={styles.address} variant="p">
          {delivery_address?.address_line_1 || ''}{' '}
          {delivery_address?.address_line_2 || ''} <br />
          {delivery_address?.city}, {delivery_address?.state}{' '}
          {delivery_address?.zipcode}
        </Typography>
      )} */}
    </div>
  );
}

export default Ticket;
